import React from "react";
import { noop } from "lodash";
import PropTypes from "prop-types";

import { useFeatureFlags } from "src/shared/components/FeatureFlags";
import {
  EXPERTS_LAUNCH_SEGMENT,
  LIKE_LISTINGS_SEGMENT,
  LUXURY_SEGMENT,
  TOWNHOUSE_SEGMENT,
  VERTICAL_LIVING_SEGMENT
} from "src/shared/experts/constants/segments";
import {
  isTownhouse,
  isVerticalLiving,
  switchSegmentName
} from "src/shared/experts/utilities/segments";
import useIsMobileDeviceSize from "src/shared/utilities/state/apollo/hooks/useIsMobileDeviceSize";

import expertProps from "../../utilities/expertProps";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import ContactField from "../ContactField";
import * as S from "./styled";

const ExpertField = ({
  className,
  expert,
  hideDisclosure,
  onChange,
  onInfoClick,
  ...props
}) => {
  const {
    buildingId,
    expertsApiUuid,
    listingId,
    searchId,
    segmentName
  } = useFeatureState();
  const isMobileDeviceSize = useIsMobileDeviceSize();
  const { flags } = useFeatureFlags(["jab_1884_new_agent_profile"], true);

  const dealType = isTownhouse(segmentName) ? "townhouse" : "recent";

  const isAPartnerText =
    "is a partner agent with the StreetEasy Experts advertising program who has experience";

  const disclosureText = switchSegmentName(segmentName, {
    [EXPERTS_LAUNCH_SEGMENT]:
      "is part of StreetEasy’s Expert Network of trusted, licensed real estate agents, who must meet our standards of service and market expertise.",
    [LIKE_LISTINGS_SEGMENT]: `${isAPartnerText} with similar homes in the area.`,
    [LUXURY_SEGMENT]: `${isAPartnerText} with similar homes in the area.`,
    [TOWNHOUSE_SEGMENT]: `${isAPartnerText} with nearby townhouses.`,
    [VERTICAL_LIVING_SEGMENT]: `${isAPartnerText} in this building.`
  });

  const advertisementDisclosure = `${expert.contact.name} ${disclosureText}`;

  return (
    <>
      <ContactField
        {...props}
        buildingId={buildingId}
        contact={expert.contact}
        dealType={dealType}
        expertsApiUuid={expertsApiUuid}
        hidePhone
        isMobile={isMobileDeviceSize}
        isNewAgentProfileEnabled={flags?.jab_1884_new_agent_profile}
        listingId={listingId}
        onChange={onChange}
        onInfoClick={onInfoClick}
        recentDealsCount={expert.recent_deals_count}
        recentDealsCountPostfix={
          isVerticalLiving(segmentName) ? "in the building" : null
        }
        searchId={searchId}
        segment={segmentName}
      />
      {advertisementDisclosure && (
        <S.AdvertisementDisclosure>
          {advertisementDisclosure}
        </S.AdvertisementDisclosure>
      )}
    </>
  );
};

ExpertField.propTypes = {
  className: PropTypes.string,
  expert: PropTypes.shape(expertProps).isRequired,
  hideDisclosure: PropTypes.bool,
  onChange: PropTypes.func,
  onInfoClick: PropTypes.func
};

ExpertField.defaultProps = {
  className: "",
  hideDisclosure: false,
  onChange: noop,
  onInfoClick: noop
};

export default ExpertField;
